import React from 'react';
import CouponCodeChecker from '../CouponCodeChecker';

const CouponUsageTab = () => <CouponCodeChecker />;

export default CouponUsageTab;
